import picklesRequests from '@/utils/constants/pickles-request.json';

export default defineNuxtPlugin(() => {
  (function () {
    // ---- Inject Dashboard Card CSS First ----
    function injectPicklesWidgetCSS() {
      if (document.getElementById('pickles-widget-style')) return;
      const style = document.createElement('style');
      style.id = 'pickles-widget-style';
      style.textContent = `
.dashboard-card {
  background: rgba(255,255,255,0.90);
  border-radius: 24px;
  box-shadow: 0 8px 32px #1e392133;
  padding: 28px 32px 28px 32px;
  margin: 28px auto;
  max-width: 430px;
  min-width: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashboard-pickles-avatar-btn {
  width: 170px;
  height: 170px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 10px #0a1b1408;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  border: none;
  cursor: pointer;
  transition: box-shadow 0.16s, transform 0.13s;
}
.dashboard-pickles-avatar-btn:active,
.dashboard-pickles-avatar-btn:focus,
.dashboard-pickles-avatar-btn:hover {
  box-shadow: 0 8px 32px #7ebc8933, 0 1.5px 8px #7ebc8925;
  transform: scale(1.05) rotate(-2deg);
}
#pickles-face, #pickles-mouth {
  width: 164px;
  height: 164px;
  border-radius: 50%;
  position: absolute;
  left: 3px;
  top: 3px;
  object-fit: cover;
  pointer-events: none;
  transition: opacity 0.2s;
}
#pickles-mouth { z-index: 5; }
#pickles-face { z-index: 2; }
.dashboard-summary-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 30px;
}
.dashboard-summary-label {
  font-size: 15px;
  color: #8a9e92;
  font-weight: 600;
  margin-bottom: 7px;
}
.dashboard-summary-text {
  color: #213b2e;
  font-size: 16.5px;
  font-weight: 500;
  background: rgba(255,255,255,0.60);
  border-radius: 16px;
  padding: 13px 18px;
  min-height: 44px;
  margin-bottom: 8px;
  box-shadow: 0 1.5px 8px #b4c6b988;
  max-width: 210px;
  text-align: center;
}
@media (max-width: 640px) {
  .dashboard-card { flex-direction: column; padding: 14px 4px; }
  .dashboard-summary-col { margin-left: 0; margin-top: 14px; }
}
    `;
      document.head.appendChild(style);
    }
    injectPicklesWidgetCSS();

    // ---- CONFIG ----
    const API_URL = 'http://localhost:8000/latest_summary_result';

    // Set actual durations in ms! (Match your play-once GIFs)
    const IDLE_GIFS = [
      { src: 'Pickles_Design/Idle_animation/breathing.gif', duration: 15000 },
      { src: 'Pickles_Design/Idle_animation/LargBreath.gif', duration: 10600 },
      { src: 'Pickles_Design/Idle_animation/LookDownHands.gif', duration: 10600 },
      { src: 'Pickles_Design/Idle_animation/right_left_look.gif', duration: 8600 },
    ];

    const WAVE_GIF = 'Pickles_Design/Wave_animation/openart-video_c79bff30_1757575247295.gif';
    const STATIC_FACE_PNG = 'scene00003.png';
    const MOUTH_PNGS = {
      A: 'scene00003.png',
      B: 'scene00004.png',
      C: 'scene00005.png',
      F: 'scene00015.png',
      E: 'scene00016.png',
      G: 'scene00041.png',
      X: 'scene00003.png',
    };

    let currentAudio = null;
    let animationFrame = null;
    let talking = false;
    let idleTimeout = null;
    let idleGIFIndex = Math.floor(Math.random() * IDLE_GIFS.length);

    // ---- IDLE GIF CONTINUOUS LOOP ----
    function startIdleGIFLoop(faceImg) {
      if (idleTimeout) clearTimeout(idleTimeout);

      function nextGIF() {
        if (talking) return; // Don't loop while talking
        // Pick a new index different from current
        let nextIdx;
        do {
          nextIdx = Math.floor(Math.random() * IDLE_GIFS.length);
        } while (IDLE_GIFS.length > 1 && nextIdx === idleGIFIndex);
        idleGIFIndex = nextIdx;
        faceImg.src = IDLE_GIFS[idleGIFIndex].src;
        idleTimeout = setTimeout(nextGIF, IDLE_GIFS[idleGIFIndex].duration);
      }

      // Start with the current index
      faceImg.src = IDLE_GIFS[idleGIFIndex].src;
      idleTimeout = setTimeout(nextGIF, IDLE_GIFS[idleGIFIndex].duration);
    }

    function stopIdleGIFLoop() {
      if (idleTimeout) clearTimeout(idleTimeout);
      idleTimeout = null;
    }

    function injectPicklesWidget() {
      const container = document.getElementById('pickles-widget');
      if (!container) return;
      container.innerHTML = `
      <div class="dashboard-card">
        <button class="dashboard-pickles-avatar-btn" id="pickles-avatar-btn" title="Click Pickles to hear summary!">
          <img id="pickles-face" src="${IDLE_GIFS[idleGIFIndex].src}" alt="Pickles Face" />
          <img id="pickles-mouth" src="${MOUTH_PNGS.A}" alt="" style="z-index:5; opacity:0;" />
        </button>
        <div class="dashboard-summary-col">
          <div class="dashboard-summary-label">AI-generated summary</div>
          <div id="pickles-summary" class="dashboard-summary-text"></div>
        </div>
      </div>
    `;

      const avatarBtn = document.getElementById('pickles-avatar-btn');
      const faceImg = document.getElementById('pickles-face');
      const mouthImg = document.getElementById('pickles-mouth');

      // Start the idle loop on load
      startIdleGIFLoop(faceImg);

      avatarBtn.addEventListener('mouseenter', () => {
        if (!talking) {
          stopIdleGIFLoop();
          faceImg.src = WAVE_GIF;
          mouthImg.style.opacity = 0;
        }
      });
      avatarBtn.addEventListener('focus', () => {
        if (!talking) {
          stopIdleGIFLoop();
          faceImg.src = WAVE_GIF;
          mouthImg.style.opacity = 0;
        }
      });
      avatarBtn.addEventListener('mouseleave', () => {
        if (!talking) {
          startIdleGIFLoop(faceImg);
          mouthImg.style.opacity = 0;
        }
      });
      avatarBtn.addEventListener('blur', () => {
        if (!talking) {
          startIdleGIFLoop(faceImg);
          mouthImg.style.opacity = 0;
        }
      });
      avatarBtn.addEventListener('click', () => {
        // Stop idle GIF loop and show static PNG + mouth for lipsync
        stopIdleGIFLoop();
        faceImg.src = STATIC_FACE_PNG;
        mouthImg.style.opacity = 1;
        playPicklesSummary(faceImg, mouthImg);
      });
    }

    async function playPicklesSummary(faceImg, mouthImg) {
      const summaryEl = document.getElementById('pickles-summary');
      summaryEl.textContent = 'Loading summary...';
      talking = true;

      try {
        // const res = await fetch(API_URL);
        // const data = await res.json();
        const data = picklesRequests;
        if (!data.audio_b64 || !data.mouth_cues) {
          summaryEl.textContent = 'No summary available.';
          talking = false;
          mouthImg.style.opacity = 0;
          startIdleGIFLoop(faceImg);
          return;
        }
        summaryEl.textContent = data.script || 'Summary unavailable.';
        const audioBlob = b64toBlob(data.audio_b64, 'audio/wav');
        const audioUrl = URL.createObjectURL(audioBlob);
        const audio = new Audio(audioUrl);

        if (currentAudio && !currentAudio.paused) {
          currentAudio.pause();
          currentAudio.currentTime = 0;
        }
        if (animationFrame) cancelAnimationFrame(animationFrame);
        mouthImg.src = MOUTH_PNGS.A;
        mouthImg.style.opacity = 1;
        faceImg.src = STATIC_FACE_PNG;
        currentAudio = audio;

        audio.onplay = () => {
          let idx = 0;
          function animate() {
            const now = audio.currentTime;
            while (idx < data.mouth_cues.length && now >= data.mouth_cues[idx].start) {
              const cue = data.mouth_cues[idx];
              const imgFile = MOUTH_PNGS[cue.mouth] || MOUTH_PNGS['A'];
              mouthImg.src = imgFile;
              idx++;
            }
            if (!audio.paused && idx < data.mouth_cues.length) {
              animationFrame = requestAnimationFrame(animate);
            } else {
              mouthImg.src = MOUTH_PNGS['A'];
              talking = false;
              mouthImg.style.opacity = 0;
              startIdleGIFLoop(faceImg);
            }
          }
          animate();
        };
        audio.onended = audio.onerror = () => {
          talking = false;
          mouthImg.style.opacity = 0;
          startIdleGIFLoop(faceImg);
        };
        audio.play();
      } catch (err) {
        summaryEl.textContent = 'Error fetching summary.';
        talking = false;
        mouthImg.style.opacity = 0;
        startIdleGIFLoop(faceImg);
        console.error(err);
      }
    }

    function b64toBlob(b64Data, contentType = 'audio/wav', sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) byteNumbers[i] = slice.charCodeAt(i);
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      return new Blob(byteArrays, { type: contentType });
    }

    // if (document.readyState !== 'loading') injectPicklesWidget();
    // else document.addEventListener('DOMContentLoaded', injectPicklesWidget);

    window.injectPicklesWidget = injectPicklesWidget;
    window.playPicklesSummary = playPicklesSummary;
    window.b64toBlob = b64toBlob;
  })();
});
